import React from 'react'
import { getAgencyPermissionsInformation } from 'shared/infrastructure/storage'
import { CustomCard, Modal } from 'shared/ui'
import { Routes } from '../../../../../config/routes'
import { NewProposalTitle } from '../Home.styles'

const ProductsModal = () => {
  const permissions = getAgencyPermissionsInformation()

  return (
    <Modal data-testid="products-modal">
      <NewProposalTitle data-testid="products-modal-title">
        Qual é o tipo de crédito da nova proposta?
      </NewProposalTitle>
      {permissions.HOME_FIN && (
        <CustomCard
          data-testid="home-fin-card"
          title="🎉 Financiamento de imóvel"
          subtitle="Financiamento imobiliário de 98 mil a 60 milhões"
          linkTo={Routes.LeadForm.HomeFinancing}
        />
      )}
      {permissions.HOME_REFI && (
        <CustomCard
          data-testid="home-card"
          title={
            <>
              Imóvel em garantia -{' '}
              <span style={{ fontWeight: 'bold' }}>Pessoa Física</span>
            </>
          }
          subtitle="Empréstimo de 50 mil a R$ 3 milhões"
          linkTo={Routes.LeadForm.Home}
        />
      )}

      {permissions.AUTO_REFI && (
        <CustomCard
          data-testid="auto-card"
          title="Veículo em garantia"
          subtitle="Empréstimo de 5 mil a R$ 150 mil"
          linkTo={Routes.LeadForm.Auto}
        />
      )}
    </Modal>
  )
}

export { ProductsModal }
